<template>
  <div class="h-full p-4 overflow-hidden bg-white rounded shadow">
    <h4 class="m-0 ds-text-base font-semibold text-gray-700 uppercase">{{title}}</h4>
    <div class="w-full mt-3 mb-4 bg-gray-300 h-1px" />
    <AthleteTestScoreCircle
      :radius="102"
      :strokeWidth="12"
      :value="(value/scale) * 100"
      strokeColor="#2DD287"
      class="w-full mb-4 text-center"
    >
      <AthleteField label="total score" class="-mb-2" secondary>
        <p class="m-0 ds-text-4xl font-semibold text-green-300">
          <TweenNum :value="tweenValue" :initial="0" :duration="2000" easing="easeOutQuart" />
          <span class="ds-text-xl text-gray-300">/{{scale}}</span>
        </p>
      </AthleteField>
    </AthleteTestScoreCircle>

    <slot></slot>
  </div>
</template>

<script>
import AthleteTestScoreCircle from "./AthleteTestScoreCircle.vue";
import AthleteField from "../../AthleteField.vue";
import TweenNum from "vue-tween-number";

export default {
  components: {
    AthleteTestScoreCircle,
    AthleteField,
    TweenNum
  },
  props: {
    title: { type: String, required: true },
    value: { type: Number, required: true },
    scale: { type: Number, required: true }
  },
  data() {
    return {
      tweenValue: 0
    };
  },
  mounted() {
    var self = this;
    var observer = new IntersectionObserver(
      function(entries) {
        if (entries[0].isIntersecting === true) {
          self.tweenValue = self.value;
          this.unobserve(self.$el);
        }
      },
      { threshold: [0.1] }
    );

    observer.observe(this.$el);
  }
};
</script>

<style scoped>
</style>
